import Swiper from 'swiper'

const homeDoorwaysSlider = document.querySelector<HTMLElement>(
    '.home-doorways-slider'
)

if (homeDoorwaysSlider) {
    new Swiper(homeDoorwaysSlider, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        enabled: true,
        breakpoints: {
            500: {
                enabled: true,
                slidesPerView: 1.75,
            },
            768: {
                enabled: true,
                slidesPerView: 2.25,
            },
            1024: {
                enabled: false,
            },
        },
    })
}
